module.exports = __webpack_public_path__ + "media/Battle to Eternity.de260b99.mp3";